import React, { useEffect, useState } from 'react';
import Slide from './Slide';

const HomepageCarousel = ({featuredContentPath, currentUserId}) => {

  const [visibleIndex, setVisibleIndex] = useState(0);
  const [featuredContent, setFeaturedContent] = useState([]);
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false)
      fetchFeaturedContent()
    }

    $(".orbit-container").on("after-slide-change.fndtn.orbit", function(event, orbit) {
      setVisibleIndex(orbit.slide_number);
    });
    $(document).foundation('orbit', 'reflow');
  })

  const fetchFeaturedContent = () => {
    $.ajax({
      type: 'GET',
      url: featuredContentPath,
      success: function(data) {
        setFeaturedContent(data)
      }
    });
  }

  const moveLeft = () => {
    let newIndex = visibleIndex == 0 ? featuredContent.length-1 : visibleIndex-1
    setVisibleIndex(newIndex)
  }

  const moveRight = () => {
    let newIndex = visibleIndex == featuredContent.length-1 ? 0 : visibleIndex+1
    setVisibleIndex(newIndex)
  }

  const dotClicked = (newIndex) => {
    setVisibleIndex(newIndex)
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: {
        event_type: 'featuredContentDotClicked',
        user_id: currentUserId,
      }
    })
  }

  const renderDots = () => {
    return featuredContent.map((cardDetails, idx) => {
      return (
        <a data-orbit-link={idx} key={idx}>
          <i
            className={`fas fa-circle dot ${idx == visibleIndex ? 'active' : ''}`}
            onClick={() => dotClicked(idx)}
            key={idx}
            id={`dot-${idx}`}/>
        </a>
      )
    })
  }

  const renderArrows = () => {
    const leftActive = visibleIndex > 0
    const rightActive = visibleIndex < featuredContent.length - 1
    
    return (
        <div className="arrows-container">
          <a
            className="carousel-arrow"
            data-orbit-link={visibleIndex-1}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M21 11.9999H3M3 11.9999L10 5M3 11.9999L10 18.9999"
                stroke={leftActive ? "black" : "#D6D9DC"}
                strokeWidth="1.5"
                strokeLinecap="square"/>
            </svg>
          </a>
          <a
            className="carousel-arrow"
            data-orbit-link={visibleIndex+1}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999"
                stroke={rightActive ? "black" : "#D6D9DC"}
                strokeWidth="1.5"
                strokeLinecap="square"/>
            </svg>
          </a>
        </div>
      )
  }

  const fireAmplitude = (type, page) => {
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: {
        event_type: 'featuredContentClicked',
        user_id: currentUserId,
        type: type,
        page: page,
      },
    })
  }

  return (
    <div className='homepage-carousel-container'>
      <div className="header-container">
        <div className="header-content">
          <h3>Featured Content</h3>
        </div>
      </div>
      <div
        className='carousel'
        role='region'>
        <ul
          className='slides-container'
          data-orbit
          data-options="animation:slide; animation_speed:500; bullets:false; slide_number:false; timer:true; timer_speed:8000; pause_on_hover:false; circular: true;">
          {featuredContent.map((content, idx) => {
            return (
              <Slide
                moveLeft={moveLeft}
                moveRight={moveRight}
                cardDetails={content}
                index={idx}
                fireAmplitude={fireAmplitude}
                visibleIndex={visibleIndex}
                key={content.id}
              />
            )
          })}
        </ul>
        <div className="navigation-container">
          <div className="dots-container">
            {renderDots()}
          </div>
          {renderArrows()}
        </div>
      </div>
    </div>
  )
}

export default HomepageCarousel;